import { render, staticRenderFns } from "./PostCreate.vue?vue&type=template&id=abceceec&scoped=true&"
import script from "./PostCreate.vue?vue&type=script&lang=js&"
export * from "./PostCreate.vue?vue&type=script&lang=js&"
import style0 from "./PostCreate.vue?vue&type=style&index=0&id=abceceec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abceceec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VIcon,VTooltip})
